import { IconButton } from '@chakra-ui/react'
import React from 'react'

import { IconCircleRemove } from '~shared-components/icons/brand/IconCircleRemove'

interface RemovePhoneButtonProps<T> {
  disabled?: boolean
  onPhoneNumberRemoved: (phoneNumber: T) => void
  phoneNumber: T
}

export const RemovePhoneButton = <T,>({
  onPhoneNumberRemoved,
  phoneNumber,
}: RemovePhoneButtonProps<T>) => (
  <IconButton
    _focus={{
      boxShadow: 'none',
      outline: '3px solid',
      outlineColor: 'blue.50',
      outlineOffset: '3px',
    }}
    aria-label="remove phone number"
    data-analyticsid="delete-phone-number-btn"
    icon={<IconCircleRemove boxSize="20px" color="red.70" />}
    justifyContent="center"
    minW="auto"
    mt={9}
    onClick={(e: React.MouseEvent) => {
      e.preventDefault()
      onPhoneNumberRemoved(phoneNumber)
    }}
    p={0}
  />
)
